import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IConversation } from '../models/chatbot.interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatbotGetConversationService {
  private readonly API_NAME: string = `${environment.conversationApiUrl}api/v1`;

  constructor(private readonly httpClient: HttpClient) {}

  public getNewConversation(): Observable<IConversation> {
    return this.httpClient.post<IConversation>(`${this.API_NAME}/conversations`, null);
  }

  public getLatestConversation(): Observable<IConversation> {
    return this.httpClient.post<IConversation>(`${this.API_NAME}/conversations/latest`, null);
  }
}
